import React, { useState, Fragment } from "react";
import { Input } from "components/input";
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons";

const PasswordInput = ({
  label,
  value,
  onChange,
  showWarning,
  warningMessage,
  warningOnlyAfterBlur,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Fragment>
      <div className="relative">
        <Input
          label={label}
          type={showPassword ? "text" : "password"}
          id="password"
          name="password"
          value={value}
          onChange={onChange}
          showWarning={showWarning}
          warningMessage={warningMessage}
          warningOnlyAfterBlur={warningOnlyAfterBlur}
          {...props}
        />
        <span
          onClick={togglePasswordVisibility}
          className="absolute right-4 top-11 h-12 transform cursor-pointer text-gray-600"
        >
          {showPassword ? (
            <EyeOpenIcon width={24} height={24} />
          ) : (
            <EyeNoneIcon width={24} height={24} />
          )}
        </span>
      </div>
    </Fragment>
  );
};

export default PasswordInput;
